export default function () {
    function buildReactiveHead(dancer, error) {
        watch(
            dancer,
            () => {
                buildHead(dancer.value, error.value);
            },
            {immediate: true},
        );
    }

    function buildHead(dancer, error) {
        if (dancer === null && !error) return useSeo().buildHeadLoading();
        if (!dancer) return useSeo().buildHeadNotFound();
        return useSeo().buildHead({
            image: dancer.dancer_image_url ? dancer.dancer_image_url : undefined,
            title: dancer.dancer_name + ' | West Coast Swing Dancer',
            description: 'View videos of this dancer.',
            index: true,
        });
    }

    return {buildReactiveHead};
}
